module.exports = __webpack_public_path__ + "img/Logo_DPEI.4cc5ef6d.png";